export default __webpack_public_path__ + "static/media/solar-panel.22e4346c.svg";